var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-badge',{attrs:{"variant":_vm.$store.getters['item/status2variant'](_vm.model.status)}},[_vm._v(_vm._s(_vm.trans.labels[
            'user_items.status.' + _vm.model.status
            ]))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }